@let isArabic = isArabic$ | async;

<div>
  <div class="d-flex justify-content-between my-2">
    <div>
      <h2 class="mb-0">
        <button
          class="bi text-primary bg-dark rounded"
          [ngClass]="isArabic ? 'bi-arrow-right-short ms-2' : 'bi-arrow-left-short me-2'"
          (click)="goBack()"
        ></button
        >{{ 'CAR_DETAILS_TITLE' | translate }}
      </h2>
    </div>
    <div>
      @if (car) {
        <span class="d-none d-md-inline-flex">
          @if (isUserLoggedIn$ | async) {
            <app-report-ad [car]="car" class="mx-1"></app-report-ad>
          }
          <app-share-button></app-share-button>
          <span *canEdit="car.user.id">
            <button class="btn text-primary bg-dark mx-1" (click)="editCar()">
              <i class="bi bi-pen-fill"></i>
            </button>
            <button class="btn btn-danger" (click)="openDeleteModal()">
              <i class="bi bi-trash-fill"></i>
            </button>
          </span>
        </span>

        <div class="dropdown d-inline-block d-md-none">
          <button
            class="btn text-primary bg-dark d-flex align-items-center gap-2"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="bi bi-three-dots-vertical"></i>
          </button>

          <ul class="dropdown-menu dropdown-menu-end py-0 icon-only transparent">
            @if (isUserLoggedIn$ | async) {
              <li>
                <app-report-ad [car]="car"></app-report-ad>
              </li>
            }

            <li>
              <app-share-button></app-share-button>
            </li>

            <li *canEdit="car.user.id">
              <button class="btn text-primary bg-dark" (click)="editCar()">
                <i class="bi bi-pen-fill"></i>
              </button>
            </li>

            <li *canEdit="car.user.id">
              <button class="btn btn-danger" (click)="openDeleteModal()">
                <i class="bi bi-trash-fill"></i>
              </button>
            </li>
          </ul>
        </div>
      }
    </div>
  </div>

  <div *ngIf="loading" class="text-center my-3">
    <app-loading></app-loading>
  </div>

  @if (car) {
    <div class="row mx-0 mb-0">
      <div
        class="col-lg-4 col-md-4 col-sm-12 text-primary bg-dark border border-1 border-primary rounded rounded-3 image-bg"
        [ngStyle]="{
          background:
            'linear-gradient(rgba(90,90,90,0.5), rgba(50,50,50,0.5)), ' +
            'url(car-brands/' +
            getCarImageUrl(car.model.toLowerCase()) +
            '.png)',
        }"
      >
        <h3 class="card-title py-3 d-flex align-items-center">
          <app-brand-logo [icon]="car.model"></app-brand-logo>{{ car.model }} {{ car.name }}
        </h3>
        <p class="d-flex justify-content-between">
          {{ 'CAR_SEARCH_YEAR' | translate }}: <strong>{{ car.year }}</strong>
        </p>
        <p class="d-flex justify-content-between">
          {{ 'CAR_SEARCH_KMS' | translate }}:
          <span
            ><strong>{{ car.kilometers | number: '1.0-0' }}</strong> {{ 'KM' | translate }}</span
          >
        </p>
        <p class="d-flex justify-content-between">
          {{ 'CAR_DETAILS_FUEL' | translate }}:
          <span
            ><strong>{{ car.fuel | translate }}</strong></span
          >
        </p>
        @if (car.performance !== null) {
          <p class="d-flex justify-content-between">
            {{ 'CAR_SEARCH_PS' | translate }}:
            <strong>{{ car.performance }} {{ 'HP' | translate }}</strong>
          </p>
        }
        <p class="d-flex justify-content-between">
          {{ 'CAR_DETAILS_GEAR' | translate }}:
          <strong>{{
            car.isManulaGear ? ('CAR_GEAR_MANUAL' | translate) : ('CAR_GEAR_AUTO' | translate)
          }}</strong>
        </p>
        <p class="d-flex justify-content-between">
          {{ 'CAR_DETAILS_BODY' | translate }}:
          <span>
            <app-car-type-logo [logo]="car.bodyType" class="px-2"></app-car-type-logo>
            <strong>{{ car.bodyType | translate }}</strong>
          </span>
        </p>
        <p class="d-flex justify-content-between">
          {{ 'CAR_SEARCH_SEAT' | translate }}: <strong>{{ car.seat }}</strong>
        </p>
        <p class="d-flex justify-content-between">
          {{ 'CAR_SEARCH_DOOR' | translate }}: <strong>{{ car.door }}</strong>
        </p>
        @if (car.weight !== null) {
          <p class="d-flex justify-content-between">
            {{ 'CAR_SEARCH_WEIGHT' | translate }}:
            <strong>{{ car.weight | number: '1.0-0' }} {{ 'KG' | translate }}</strong>
          </p>
        }
        @if (car.cylinder !== null) {
          <p class="d-flex justify-content-between">
            {{ 'CAR_SEARCH_CYLINDER' | translate }}: <strong>{{ car.cylinder }}</strong>
          </p>
        }
        @if (car.driveType !== null) {
          <p class="d-flex justify-content-between">
            {{ 'CAR_SEARCH_DRIVE_TYPE' | translate }}:
            <strong>{{ car.driveType | translate }}</strong>
          </p>
        }
        <p class="d-flex justify-content-between">
          {{ 'CAR_DETAILS_COLOR' | translate }}:
          <span>
            <span class="color-box mx-2" [style.background]="carColorCode"></span>
            <strong>{{ car.color | translate }}</strong>
          </span>
        </p>
        @if (car.interiorColor !== null) {
          <p class="d-flex justify-content-between">
            {{ 'CAR_DETAILS_INTERIOR_COLOR' | translate }}:
            <span>
              <span class="color-box mx-2" [style.background]="carInteriorColorCode"></span>
              <strong>{{ car.interiorColor | translate }}</strong>
            </span>
          </p>
        }
        @if (car.seatCover !== null) {
          <p class="d-flex justify-content-between">
            {{ 'CAR_SEARCH_SEAT_COVER' | translate }}:
            <strong>{{ car.seatCover | translate }}</strong>
          </p>
        }
        <p class="d-flex justify-content-between">
          {{ 'CAR_DETAILS_CONDITION' | translate }}:
          <strong>{{ car.condition | translate }}</strong>
        </p>
        <div class="row">
          <div class="col-6">
            <p>
              <i class="bi boolean-status-icon" [ngClass]="car.isInstallmentAvailable === true ? 'bi-check-square-fill text-success' : 'bi-x-square-fill text-danger'"></i>
              {{ 'PAY_IN_INSTALLMENTS' | translate }}
            </p>
          </div>
          @if (car.hasSunroof !== null && car.hasSunroof !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasSunroof === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_NEW_SELECT_SUNROOF' | translate }}
              </p>
            </div>
          }
          @if (car.hasPanoramicSunroof !== null && car.hasPanoramicSunroof !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasPanoramicSunroof === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_NEW_SELECT_PANORAMIC_SUNROOF' | translate }}
              </p>
            </div>
          }
          @if (car.isAccident !== null && car.isAccident !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.isAccident === false
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_SEARCH_ACCIDENT' | translate }}
              </p>
            </div>
          }
          @if (car.withWarranty !== null && car.withWarranty !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.withWarranty === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_SEARCH_WARRANTY' | translate }}
              </p>
            </div>
          }
          @if (car.hasFrontCamera !== null && car.hasFrontCamera !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasFrontCamera === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_FRONT_CAMERA' | translate }}
              </p>
            </div>
          }
          @if (car.hasRearCamera !== null && car.hasRearCamera !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasRearCamera === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_REAR_CAMERA' | translate }}
              </p>
            </div>
          }
          @if (car.hasCentralLock !== null && car.hasCentralLock !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasCentralLock === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_CENTRAL_LOCK' | translate }}
              </p>
            </div>
          }
          @if (car.hasKeylessEntry !== null && car.hasKeylessEntry !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasKeylessEntry === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_KEYLESS_ENTRY' | translate }}
              </p>
            </div>
          }
          @if (car.hasPushButtonStart !== null && car.hasPushButtonStart !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasPushButtonStart === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_PUSH_BUTTON_START' | translate }}
              </p>
            </div>
          }
          @if (car.hasSportSeats !== null && car.hasSportSeats !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasSportSeats === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_SPORT_SEATS' | translate }}
              </p>
            </div>
          }
          @if (car.hasCruiseControl !== null && car.hasCruiseControl !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasCruiseControl === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_CRUISE_CONTROL' | translate }}
              </p>
            </div>
          }
          @if (car.hasAbs !== null && car.hasAbs !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasAbs === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_ABS' | translate }}
              </p>
            </div>
          }
          @if (car.hasAlarmSystem !== null && car.hasAlarmSystem !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasAlarmSystem === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_ALARM_SYSTEM' | translate }}
              </p>
            </div>
          }
          @if (car.hasSeatHeating !== null && car.hasSeatHeating !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasSeatHeating === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_SEAT_HEATING' | translate }}
              </p>
            </div>
          }
          @if (car.hasElectricSeats !== null && car.hasElectricSeats !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasElectricSeats === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_ELECTRIC_SEATS' | translate }}
              </p>
            </div>
          }
          @if (car.hasMemorySeats !== null && car.hasMemorySeats !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasMemorySeats === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_MEMORY_SEATS' | translate }}
              </p>
            </div>
          }
          @if (car.hasMassageSeats !== null && car.hasMassageSeats !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasMassageSeats === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_MASSAGE_SEATS' | translate }}
              </p>
            </div>
          }
          @if (car.hasVentilatedSeats !== null && car.hasVentilatedSeats !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasVentilatedSeats === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_VENTILATED_SEATS' | translate }}
              </p>
            </div>
          }
          @if (car.hasSteeringWheelHeating !== null && car.hasSteeringWheelHeating !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasSteeringWheelHeating === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_STEERING_WHEEL_HEATING' | translate }}
              </p>
            </div>
          }
          @if (car.hasElectricWindows !== null && car.hasElectricWindows !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasElectricWindows === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_ELECTRIC_WINDOWS' | translate }}
              </p>
            </div>
          }
          @if (car.hasElectricMirrors !== null && car.hasElectricMirrors !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasElectricMirrors === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_ELECTRIC_MIRRORS' | translate }}
              </p>
            </div>
          }
          @if (car.hasElectricTailgate !== null && car.hasElectricTailgate !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasElectricTailgate === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_ELECTRIC_TAILGATE' | translate }}
              </p>
            </div>
          }
          @if (car.hasReserveTire !== null && car.hasReserveTire !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasReserveTire === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_RESERVE_TIRE' | translate }}
              </p>
            </div>
          }
          @if (car.hasWirelessCharging !== null && car.hasWirelessCharging !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasWirelessCharging === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_WIRELESS_CHARGING' | translate }}
              </p>
            </div>
          }
          @if (car.hasInfotainmentScreen !== null && car.hasInfotainmentScreen !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasInfotainmentScreen === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_INFOTAINMENT_SCREEN' | translate }}
              </p>
            </div>
          }
          @if (car.has220VoltOutlet !== null && car.has220VoltOutlet !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.has220VoltOutlet === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_220_VOLT_OUTLET' | translate }}
              </p>
            </div>
          }
          @if (car.has360Camera !== null && car.has360Camera !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.has360Camera === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_360_CAMERA' | translate }}
              </p>
            </div>
          }
          @if (car.hasFrontSensor !== null && car.hasFrontSensor !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasFrontSensor === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_FRONT_SENSOR' | translate }}
              </p>
            </div>
          }
          @if (car.hasRearSensor !== null && car.hasRearSensor !== undefined) {
            <div class="col-6">
              <p>
                <i
                  class="bi boolean-status-icon"
                  [ngClass]="
                    car.hasRearSensor === true
                      ? 'bi-check-square-fill text-success'
                      : 'bi-x-square-fill text-danger'
                  "
                ></i>
                {{ 'CAR_HAS_REAR_SENSOR' | translate }}
              </p>
            </div>
          }
        </div>

        <p class="d-flex justify-content-between" *canEdit="car.user.id">
          {{ 'CAR_DETAILS_USER_LIKES' | translate }}:
          <strong>{{ car.carLikes }} <i class="bi bi-heart-fill"></i></strong>
        </p>
      </div>
      <div class="col-lg-8 col-md-8 col-sm-12 p-0 border border-1 border-primary rounded rounded-3">
        <div class="card">
          <car-images-carousel
            [car]="car"
            carouselId="carDetails"
            [displayIndicator]="true"
          ></car-images-carousel>
        </div>
      </div>
    </div>
    <div class="row mx-0">
      <div
        class="col-lg-6 col-md-6 col-sm-12 text-primary bg-dark border border-1 border-primary rounded rounded-3"
      >
        <app-seller-details [ad]="car"></app-seller-details>
      </div>
      <div
        class="col-lg-6 col-md-6 col-sm-12 text-primary bg-dark border border-1 border-primary rounded rounded-3 py-2"
      >
        <p>{{ 'CAR_DETAILS_LOCATION' | translate }}:</p>
        <p class="text-pre-line">
          <strong>{{ car.city | syrianCity }}</strong>
        </p>
        @if (car.addressText; as addressText) {
          <p class="text-pre-line">
            <strong>{{ addressText }}</strong>
          </p>
        }
        @if (car.latitude && car.longitude) {
          <p>
            <app-google-maps-location
              [lat]="car.latitude"
              [lng]="car.longitude"
            ></app-google-maps-location>
          </p>
        }
        @if (car.latitude && car.longitude) {
          <app-item-location
            [latitude]="car.latitude"
            [longitude]="car.longitude"
            [icon]="customIcon"
            [zoom]="7"
          >
          </app-item-location>
        }
      </div>
    </div>

    <div class="modal fade" id="imageModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content bg-dark text-center">
          <button
            type="button"
            class="btn-close btn-close-white position-absolute top-0 start-50 end-0 mt-3 z2000 h4"
            data-bs-dismiss="modal"
            (click)="closeModal()"
          ></button>

          <div class="modal-body p-0">
            <car-images-carousel
              [car]="car"
              carouselId="carModal"
              imagClass="contain"
            ></car-images-carousel>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="deleteConfirmModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered confirm-modal">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ 'DELETE_HEADER' | translate }}</h5>
          </div>

          <div class="modal-body">
            @if (car.status === statuses.Sold) {
              <p>{{ 'DELETE_MESSAGE' | translate }}</p>
            } @else {
              <p>{{ 'DELETE_MESSAGE_OPTION' | translate }}</p>

              <div
                class="form-check"
                [class.rtl-radio]="isArabic"
                *ngFor="let reason of deleteReasons"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  [value]="reason"
                  name="deleteReason"
                  [(ngModel)]="selectedReason"
                  id="{{ reason }}"
                />
                <label class="form-check-label" [for]="reason">
                  {{ reason | translate }}
                </label>
              </div>
            }
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              {{ 'CANCEL_BUTTON' | translate }}
            </button>

            <button
              type="button"
              class="btn btn-danger"
              (click)="deleteCar()"
              [disabled]="car.status !== statuses.Sold && !selectedReason"
            >
              {{ 'DELETE_BUTTON' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
